"use client";

import React from "react";
import { cn } from "@/lib/utils";

type HeadingLevel = 1 | 2 | 3 | 4;

type SectionHeadingProps = {
  children: React.ReactNode;
  level?: HeadingLevel;
  align?: "left" | "center";
  className?: string;
};

const levelToTag: Record<HeadingLevel, keyof JSX.IntrinsicElements> = {
  1: "h1",
  2: "h2",
  3: "h3",
  4: "h4",
};

const levelToSize: Record<HeadingLevel, string> = {
  1: "text-4xl md:text-5xl",
  2: "text-3xl md:text-4xl",
  3: "text-2xl md:text-3xl",
  4: "text-xl md:text-2xl",
};

export function SectionHeading({
  children,
  level = 2,
  align = "left",
  className,
}: SectionHeadingProps) {
  const Tag = levelToTag[level] as any;
  return (
    <Tag
      className={cn(
        levelToSize[level],
        "font-normal",
        align === "center" ? "text-center" : "text-left",
        className,
      )}
    >
      {children}
    </Tag>
  );
}

export default SectionHeading;


